import { AxiosRequestConfig } from 'axios';
import { requester } from '../config';

export const fetchUserTodos = (data = {}, config: AxiosRequestConfig = {}) =>
  requester.post('/user_todos', data, config);

export const fetchUserActivities = (
  data: { limit?: number } = {},
  config: AxiosRequestConfig = {}
) => requester.post('/user_activities', data, config);

export const fetchUserTransactions = (
  data = {},
  config: AxiosRequestConfig = {}
) => requester.post('/user_transactions', data, config);
